<template>
  <v-card
    dark
    class="pa-2"
    width="100%"
    color="rgba(0,0,0,0.3)"
    style="border: 1px solid #757575"
  >
    <h5 class="text-center mb-1">発表中の警報・注意報</h5>
    <v-row no-gutters align="center">
      <template v-if="city">
        <v-chip
          v-for="alert in city.alerts"
          :key="alert"
          :color="getColor(alert)"
          :text-color="getColor(alert) === 'warning' ? 'black' : null"
          small
          class="mr-1 mb-1"
        >
          {{ alert }}
        </v-chip>
      </template>
      <template v-else>
        <div class="text-center" style="width: 100%">
          なし
        </div>
      </template>
    </v-row>
  </v-card>
</template>
<script>
import * as axiosHelper from "../utils/axiosHelper";
import _ from "lodash";
const ALERT_POINT = "JPNB";
const ALERT_CITY = "1738600";

export default {
  name: "WarningStatus",
  data() {
    return {
      city: null
    };
  },
  computed: {
    baseDate() {
      return this.$store.getters.baseDate;
    }
  },
  watch: {
    baseDate() {
      this.setStatus();
    }
  },
  created() {
    this.setStatus();
  },
  methods: {
    async setStatus() {
      this.city = null;
      const status = await this.fetchStatus();
      const area = _.find(status, { id: ALERT_POINT });
      if (area) {
        const city = _.find(area.cities, { id: ALERT_CITY });
        if (city) {
          this.city = city;
        }
      }
    },
    async fetchStatus() {
      const params = {
        point: ALERT_POINT,
        city: ALERT_CITY,
        date: this.baseDate.format("YYYY/MM/DD HH:mm")
      };
      return await axiosHelper.get("/alert/status", params);
    },
    getColor(alert) {
      if (alert.includes("特別警報")) {
        return "black";
      } else if (alert.includes("危険警報")) {
        return "purple";
      } else if (alert.includes("警報")) {
        return "red";
      } else if (alert.includes("注意報")) {
        return "warning";
      }
    }
  }
};
</script>
